import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import config from "../../config";
import Toast from "../Common/Toast";

const AdminOtp = () => {
    const role = useSelector((state) => state.user.role);
    const isAdminUser = Number(role) === 1;

    const [otp, setOtp] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [toast, setToast] = useState({ show: false, message: "", type: "info" });

    const showToast = (message, type = "info") => {
        setToast({ show: true, message, type });
    };

    const getErrorMessage = (error, fallbackMessage) => {
        const apiMessage = error?.response?.data?.message || error?.response?.data?.messages;

        if (Array.isArray(apiMessage) && apiMessage.length > 0) {
            return apiMessage.join(", ");
        }

        if (typeof apiMessage === "string" && apiMessage.trim() !== "") {
            return apiMessage;
        }

        if (typeof error?.response?.data === "string" && error.response.data.trim() !== "") {
            return error.response.data;
        }

        return fallbackMessage;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!isAdminUser) {
            showToast("Only Admin can submit OTP.", "error");
            return;
        }

        const trimmedOtp = otp.trim();

        if (!trimmedOtp) {
            showToast("Please enter OTP.", "warning");
            return;
        }

        if (trimmedOtp.length !== 6) {
            showToast("OTP must be exactly 6 digits.", "warning");
            return;
        }

        setSubmitting(true);
        try {
            const response = await axios.post(`${config.BL_API_URL}/mofsl/v1/otp`, {
                otp: trimmedOtp,
            });

            const status = response?.data?.status;
            const message = response?.data?.message || "OTP accepted";

            if (status && String(status).toLowerCase() === "ok") {
                showToast(message, "success");
                setOtp("");
            } else {
                showToast(message || "OTP submission failed.", "error");
            }
        } catch (error) {
            showToast(getErrorMessage(error, "Failed to submit OTP."), "error");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="my-12 md:px-14 p-4 max-w-screen-md mx-auto">
            <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ show: false, message: "", type: "info" })}
            />

            <div className="border rounded-lg bg-white shadow-sm p-6">
                <h1 className="text-xl font-semibold text-gray-800">Admin OTP Submission</h1>
                <p className="text-sm text-gray-500 mt-1">Enter OTP and submit to MOFSL endpoint.</p>

                {!isAdminUser ? (
                    <div className="mt-5 rounded-md border border-red-200 bg-red-50 text-red-700 px-4 py-3 text-sm">
                        Access denied. This screen is available only for Admin users.
                    </div>
                ) : (
                    <form className="mt-6" onSubmit={handleSubmit}>
                        <label htmlFor="admin-otp" className="block text-sm font-medium text-gray-700 mb-2">
                            OTP
                        </label>
                        <input
                            id="admin-otp"
                            name="otp"
                            type="text"
                            inputMode="numeric"
                            maxLength={6}
                            value={otp}
                            onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
                            placeholder="Enter OTP"
                            className="w-full md:w-96 border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />

                        <button
                            type="submit"
                            disabled={submitting}
                            className="mt-4 inline-flex items-center px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                            {submitting ? "Submitting..." : "Submit OTP"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default AdminOtp;
